// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3mK2E","alert":"SettungsInbox_alert__24Qbq"};